<template>
  <div  
    class="form-row" 
    :class="{
      'form-row--full': full,
      'form-row--tall': tall,
      'form-row--fixed': size === 4,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  full?: boolean;
  size?: number;
  tall?: boolean;
}>();
</script>

<style lang="scss">
.form-row {
  align-items: flex-start;
  display: flex;
  gap: variables.$sizing-sm;
  justify-content: space-between;
  margin-bottom: variables.$sizing-lg;
  width: 100%;

  &.form-row--full {
    > .form-cell {
      flex-basis: 100%;
    }

    > .form-cell--button {
      flex-basis: 42px;
    }
  }

 &.form-row--fixed {
    .form-cell {
      flex-basis: calc(25% - 16px);
      flex-grow: 0;
      flex-shrink: 0;
    }
  }

  &.form-row--tall {
    margin-bottom: variables.$sizing-xl;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
